<template>
  <v-app>
    <AppBar @toggleTheme="onClick"/>
    <v-main>
      <v-container fill-height>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar.vue";

export default {
  name: 'App',
  methods: {
    onClick () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('logixpie-theme', JSON.stringify(this.$vuetify.theme.dark));
    }
  },
  components: {
    AppBar,
  },
  beforeMount() {
    this.$vuetify.theme.dark = JSON.parse(localStorage.getItem('logixpie-theme'))
  }
};
</script>

<style>
#app div {
  font-family: Urdu, sans-serif !important;
}
#head {
  font-family: Urdu, sans-serif !important;
}
@font-face {
  font-family: "Urdu";
  src: local("Urdu"),
  url(./fonts/Urdu.ttf) format("truetype");
}
</style>